module.exports = new __parcel__URL__("choose_2.bc920158.png").toString();